import {
    JIRA_DETAILS_OPEN_MODAL,
    JIRA_SEARCH_DETAILS_REQUEST,
    JIRA_SEARCH_DETAILS_RESULT
} from 'Redux/actionTypes';

export const jiraDetailsOpenModal = (open, user, range) => ({
    type: JIRA_DETAILS_OPEN_MODAL,
    payload: { open, user, range }
})

export const jiraSearchDetailsRequest = (user) => ({
    type: JIRA_SEARCH_DETAILS_REQUEST,
    payload: user
})

export const jiraSearchDetailsResult = (data) => ({
    type: JIRA_SEARCH_DETAILS_RESULT,
    payload: data
})